import { BaseBus } from "./BaseBus";

export class v_EmployeeBus extends BaseBus {
    constructor(busObj: v_EmployeeBus = null) {
        super(busObj);
    }

    empNo: number;
    firstName: string;
    lastName: string;
    legalName: string;
    contactEmail: string;
    
}
